import '../Tests.css';
import { useContext, useEffect, useState } from 'react';
import { SharedVariableContext } from '../../../App';
import translations from './Textes/BombJackExtraSugarEditionTraductions';
// Images
import BombJackExtraSugarEdition0 from './Assets/BombJackExtraSugarEdition/BombJackExtraSugarEdition-0.png';
import BombJackExtraSugarEdition1 from './Assets/BombJackExtraSugarEdition/BombJackExtraSugarEdition-1.png';
import BombJackExtraSugarEdition2 from './Assets/BombJackExtraSugarEdition/BombJackExtraSugarEdition-2.png';
import BombJackExtraSugarEdition3 from './Assets/BombJackExtraSugarEdition/BombJackExtraSugarEdition-3.png';
import BombJackExtraSugarEdition4 from './Assets/BombJackExtraSugarEdition/BombJackExtraSugarEdition-4.png';
import BombJackExtraSugarEdition5 from './Assets/BombJackExtraSugarEdition/BombJackExtraSugarEdition-5.png';
import LaCrypteDesMaudits from './Assets/BombJackExtraSugarEdition/LaCrypteDesMaudits.png';
import BobWinner from './Assets/BombJackExtraSugarEdition/BobWinner.png';

export default function TestBombJackExtraSugarEdition() {
  const { MajTypeDePage, MajIllustration, selectedOption } = useContext(SharedVariableContext);

  // Constantes pour le picture viewer
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  // Sélectionner la langue, avec français comme langue par défaut
  const lang = translations[selectedOption.value] || translations.fr;

  useEffect(() => {
    MajTypeDePage('Test');
    MajIllustration('BombJackExtraSugarEdition');
  }, [MajTypeDePage, MajIllustration]);


// Fonction pour ouvrir la modale avec l'image sélectionnée
  const openModal = (imageSrc) => 
                                  {
                                  setSelectedImage(imageSrc);
                                  setModalOpen(true);
                                  };

  // Fonction pour fermer la modale
  const closeModal = () => 
                            {
                            setModalOpen(false);
                            setSelectedImage(null);
                            };

  return (
    <div id="Test">
      <div id="TestFenetre">
        <h1>{lang.title}</h1>

        {/* Section Intro */}
        <p>{lang.intro.p1}</p>
        <p>{lang.intro.p2}</p>
        <p>{lang.intro.p3}</p>
        <p className="screenshot">
          <img
            className="screenshot_image"
            src={BombJackExtraSugarEdition1}
            alt="Bombjack old"
            onClick={() => openModal(BombJackExtraSugarEdition1)}
          />
          <span className="sousTitreImage">{lang.imageCaptions.bombJackOld}</span>
        </p>
        <p>{lang.intro.p4}</p>
        <p>{lang.intro.p5}</p>
        <p>{lang.intro.p6}</p>
        <p>{lang.intro.p7}</p>
        <p>{lang.intro.p8}</p>
        <p>{lang.intro.p9}</p>
        <p>{lang.intro.p10}</p>
        
        <p className="screenshot">
          <img
            className="screenshot_image cursor-pointer"
            src={BobWinner}
            alt="Bob Winner"
            onClick={() => openModal(BobWinner)}
          />
          <span className="sousTitreImage">{lang.imageCaptions.bobWinner}</span>
        </p>
        <p className="screenshot">
          <img
            className="screenshot_image cursor-pointer"
            src={LaCrypteDesMaudits}
            alt="La Crypte des maudits"
            onClick={() => openModal(LaCrypteDesMaudits)}
          />
          <span className="sousTitreImage">{lang.imageCaptions.laCrypteDesMaudits}</span>
        </p>
        <p>{lang.intro.p11}</p>
        {/* Section Bomb Jack */}
        <h2>{lang.bombJack.title}</h2>
        <p>{lang.bombJack.p1}</p>
        <p>{lang.bombJack.p2}</p>
        <p>{lang.bombJack.p3}</p>
        <p>{lang.bombJack.p4}</p>

        {/* Section Analyse */}
        <h2>{lang.analyse.title}</h2>
        <p>{lang.analyse.p1}</p>
        <p>{lang.analyse.p2}</p>

        {/* Section Analyse Graphique */}
        <h2>{lang.analyseGraphique.title}</h2>
        <p>{lang.analyseGraphique.p1}</p>
        <p className="screenshot">
          <img
            className="screenshot_image cursor-pointer"
            src={BombJackExtraSugarEdition0}
            alt="Écran d'accueil"
            onClick={() => openModal(BombJackExtraSugarEdition0)}
          />
          <span className="sousTitreImage">{lang.imageCaptions.menuScreen}</span>
        </p>
        <p>{lang.analyseGraphique.p2}</p>
        <p className="screenshot">
          <img
            className="screenshot_image cursor-pointer"
            src={BombJackExtraSugarEdition2}
            alt="Écran de jeu 1"
            onClick={() => openModal(BombJackExtraSugarEdition2)}
          />
          <span className="sousTitreImage">{lang.imageCaptions.level1}</span>
        </p>
        <p className="screenshot">
          <img
            className="screenshot_image cursor-pointer"
            src={BombJackExtraSugarEdition3}
            alt="Écran de jeu 2"
            onClick={() => openModal(BombJackExtraSugarEdition3)}
          />
          <span className="sousTitreImage">{lang.imageCaptions.level2}</span>
        </p>
        <p>{lang.analyseGraphique.p3}</p>
        <p>{lang.analyseGraphique.p4}</p>
        <p className="screenshot">
          <img
            className="screenshot_image cursor-pointer"
            src={BombJackExtraSugarEdition4}
            alt="Écran de jeu 4"
            onClick={() => openModal(BombJackExtraSugarEdition4)}
          />
          <span className="sousTitreImage">{lang.imageCaptions.castle}</span>
        </p>
        <p>{lang.analyseGraphique.p5}</p>

        {/* Section Gameplay */}
        <h2>{lang.gameplay.title}</h2>
        <p>{lang.gameplay.p1}</p>
        <p>{lang.gameplay.p2}</p>
        <p>{lang.gameplay.p3}</p>

        {/* Section Son */}
        <h2>{lang.son.title}</h2>
        <p>{lang.son.p1}</p>

        {/* Section Options et Ajouts */}
        <h2>{lang.options.title}</h2>
        <p>{lang.options.p1}</p>
        <p className="screenshot">
          <img
            className="screenshot_image cursor-pointer"
            src={BombJackExtraSugarEdition5}
            alt="Écran de jeu 5"
            onClick={() => openModal(BombJackExtraSugarEdition5)}
          />
          <span className="sousTitreImage">{lang.imageCaptions.newBackground}</span>
        </p>
        <p>{lang.options.p2}</p>

        {/* Section Conclusion */}
        <h2>{lang.conclusion.title}</h2>
        <p>{lang.conclusion.p1}</p>
        <p>{lang.conclusion.p2}</p>
        <p>{lang.conclusion.p3}</p>
        <p>{lang.conclusion.p4}</p>

{/* Modale pour afficher l'image en taille réelle */}
        {modalOpen && (
          <div className="modal-overlay" onClick={closeModal}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <button className="modal-close" onClick={closeModal}>
                ✕
              </button>
              <img src={selectedImage} alt="taille réelle" className="modal-image" />
            </div>
          </div>
        )}


      </div>
    </div>
  );
}